import React from 'react';
import gql from 'graphql-tag';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { ChildProps } from 'react-apollo';
import {
  CoreCreditCardWalletCreateFormLayout,
} from '../schemas/rql';

import CreditCardCreateForm, { CreditCardCreateFormFragment } from './credit_card_create_form';
import { RCLoadingBars } from '@reverbdotcom/commons/src/rc/RCLoadingBars';

type Props = ChildProps<unknown, CoreCreditCardWalletCreateFormLayout.Query>;

export function CreditCardWalletCreateFormLayout(props: Props) {
  if (!props.data || props.data.loading) {
    return (
      <div className="d-flex fx-justify-center mtb-1">
        <RCLoadingBars />
      </div>
    );
  }

  return (
    <CreditCardCreateForm
      me={props.data.me}
      countries={props.data.countries.countries}
    />
  );
}

const withQuery = withGraphql<Props>(
  gql`
    query Core_CreditCardWallet_CreateFormLayout {
      countries {
        countries {
          countryCode
          name
          subregionRequired
          subregions {
            code
            name
          }
        }
      }
      me {
        uuid
        ...CreditCardCreateFormFields
      }
    }
    ${CreditCardCreateFormFragment}
  `,
);

export default withQuery(CreditCardWalletCreateFormLayout);
